/***************************************************************************/
"use client";
/***************************************************************************/

import * as ToastPrimitives from "@radix-ui/react-toast";
import * as React from "react";
import { cn } from "../../../utils/css";

const ToastDescription = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Description>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Description>
>(({ className, ...props }, ref) => {
  return (
    <ToastPrimitives.Description
      ref={ref}
      className={cn("text-sm", className)}
      {...props}
    />
  );
});
ToastDescription.displayName = ToastPrimitives.Description.displayName;

export { ToastDescription };
